import { render, staticRenderFns } from "./Updatebanner.vue?vue&type=template&id=70c8134a&scoped=true&"
import script from "./Updatebanner.vue?vue&type=script&lang=js&"
export * from "./Updatebanner.vue?vue&type=script&lang=js&"
import style0 from "./Updatebanner.vue?vue&type=style&index=0&id=70c8134a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c8134a",
  null
  
)

export default component.exports